"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactUsFormReducer = void 0;
const ts_pattern_1 = require("ts-pattern");
const state_1 = require("../../redux/state");
const contactUsFormReducer = (state) => (action) => (0, ts_pattern_1.match)(action)
    .with({ type: 'SET_CONTACT_FORM_ERROR' }, _action => state.update(state_1.stateKeys.contactForm, _state => ({
    ..._state,
    error: _action.payload
})))
    .with({ type: 'SET_CONTACT_FORM_SUBMIT' }, _action => state.update(state_1.stateKeys.contactForm, _state => ({
    ..._state,
    loading: _action.payload
})))
    .with({ type: 'SET_CONTACT_FORM_SUCCESS' }, _action => state.update(state_1.stateKeys.contactForm, _state => ({
    ..._state,
    value: _action.payload
})))
    .exhaustive();
exports.contactUsFormReducer = contactUsFormReducer;
//# sourceMappingURL=reducer.js.map